import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class InfoDualReplace extends DesigntimeComponent {
    static staticName = "Info (Dual Replace)";
    static staticId = "infoDualReplace";

    constructor(identifyer) {
        super(identifyer, 5);

        this.values = {
            trueheader: new LiquidString("Selector=true: You spend {{url:monthlySpending}} £/month with Mr Green. That’s less than the average player in the United Kingdom, who spends {{url:monthlySpending}} £/month*.", `${this.id}_trueheader`),
            truetext: new LiquidString("truetext", `${this.id}_truetext`),
            falseheader: new LiquidString("Selector=false: You spend {{url:monthlySpending}} £/month with Mr Green. That’s less than the average player in the United Kingdom, who spends {{url:monthlySpending}} £/month*.", `${this.id}_falseheader`),
            falsetext: new LiquidString("falsetext", `${this.id}_falsetext`),
            subtext: new LiquidString("*Data is based on Swedish research, the median of active players’ stake per month", `${this.id}_subtext`),
            buttontext: { value: "Next" },
            imageurl: { value: "placeholder.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true }
        };

        this.params = {
            selector: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        let $view = $("<div></div>");
        let $textbox = $("<div class='sid-question-text'></div>");

        if (this.params.selector.value) {
            $textbox.append(this.values.trueheader.getTag("h3"));
            $textbox.append(this.values.truetext.getTag("p"));
        }
        else {
            $textbox.append(this.values.falseheader.getTag("h3"));
            $textbox.append(this.values.falsetext.getTag("p"));
        }

        $textbox.append("<p class='sid-info-insert-asterisk'>" + this.values.subtext.getEditedTemplate() + "</p>");
        $view.append($textbox);

        let $imagebox = $("<div class='sid-question-image'></div>");
        if (this.values.imageurl.value) {
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }

        return $view;
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        super.onRuntimeChanged(eventParams);

        for (var paramIndex in this.params) {
            if (this.params[paramIndex].key == eventParams.key) {
                this.params[paramIndex].value = eventParams.value;
            }
        }

        this.replaceParameter();
    }

    replaceParameter() {
        let $rtframe = componentHelpers.getRtFrame(this.id).find(`.sid-question-text`);

        $rtframe.empty()

        if (this.params.selector.value) {
            $rtframe.append(this.values.trueheader.getTag("h3"));
            $rtframe.append(this.values.truetext.getTag("p"));
        }
        else {
            $rtframe.append(this.values.falseheader.getTag("h3"));
            $rtframe.append(this.values.falsetext.getTag("p"));
        }
    }

    importModel(model) {
        for (var param in model.params) {
            for (var i in this.values) {
                if (this.values[i] instanceof LiquidString)
                    this.values[i].replace(`{{${param}}}`, `{{${model.params[param].key}}}`);
            }
        }
        delete model.params.parameter1;
        delete model.params.parameter2;
        delete model.params.parameter3;

        super.importModel(model);
    }
}

export { InfoDualReplace }


